
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import Tabs from "./Tabs";
import TabPane from "./TabPane";

import AccountBasicInfo from "./AccountBasicInfo";
import AccountModifyPwd from "./AccountModifyPwd";
// import AccountFindPwd from "./AccountFindPwd";
import AccountBindPhone from "./AccountBindPhone";
export class Account extends Component {
  state = {
    defaultActiveKey: 0,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    //路由绑定
    let { pathname } = this.props.history.location;
    pathname = pathname.slice(pathname.lastIndexOf('/') + 1, pathname.length);
    this.setState({
      defaultActiveKey: parseInt(pathname, 10),
    })
  }
  updateRouter(activeKey) {
    this.props.history.replace(`/center/account/${activeKey}`)
  }
  render() {
    const { defaultActiveKey } = this.state;
    return (
      <div className="center-account">
        <div className="tabs">
          <Tabs
            {...this.props}
            defaultActiveKey={defaultActiveKey}
            onTabsChange={(activeKey) => {
              this.setState({
                defaultActiveKey: activeKey
              });
              this.updateRouter(activeKey);
            }}
            tabs={[{ Name: "基本资料" }, { Name: "修改密码" }, { Name: "绑定手机" }]}
          />
        </div>
        <TabPane {...this.props} defaultActiveKey={defaultActiveKey}>
          <AccountBasicInfo {...this.props} tabToPhone={() => {
            this.setState({ defaultActiveKey: 2 });
            this.updateRouter(2);
          }} />
          <AccountModifyPwd {...this.props} />
          {/* <AccountFindPwd {...this.props} /> */}
          <AccountBindPhone {...this.props} />
        </TabPane>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Account);



// WEBPACK FOOTER //
// ./src/features/center/Account.js